import React, { memo } from 'react';
import { TopPicks4U } from '@browsing/top-picks-4U';
import { ContinueShoppingCarousel } from '@client/components/continue-shopping';
import { CampaignBlock, Slot, DeclarativeGrid } from '../components';
import { SemanticArticleCarousel } from '../../../semantic-article-carousel';
import { NewDealsCarousel } from '../../../new-deals-today';
import { useGridLayoutContext } from '../context/GridLayoutContext';

const ThreeColumnLayoutComponent: React.FC = () => {
    const { topPicks4UGenderData, layoutConfig, isContinueShopping } = useGridLayoutContext();
    const { gender, profileFashionPreference, selectedFashionPreference } = topPicks4UGenderData;
    const { newDealPlacement } = layoutConfig;

    return (
        <DeclarativeGrid>
            {/* Header section with showstoppers */}
            <CampaignBlock slots={[Slot.LARGE_SQUARE, Slot.SQUARE, Slot.SQUARE]} />
            <SemanticArticleCarousel />
            <TopPicks4U
                gender={gender}
                profileFashionPreference={profileFashionPreference}
                selectedFashionPreference={selectedFashionPreference}
            />

            {newDealPlacement === 'afterTopPicks' && <NewDealsCarousel />}

            <CampaignBlock slots={[Slot.SQUARE, Slot.HORIZONTAL_RECTANGLE]} />

            {newDealPlacement === 'afterSecondBlock' && <NewDealsCarousel />}

            <CampaignBlock
                slots={[
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                ]}
            />

            {isContinueShopping && <ContinueShoppingCarousel />}

            <CampaignBlock slots={[Slot.HORIZONTAL_RECTANGLE, Slot.SQUARE]} />
            <CampaignBlock
                slots={[
                    Slot.LARGE_SQUARE,
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                ]}
            />
            <CampaignBlock slots={[Slot.SQUARE, Slot.HORIZONTAL_RECTANGLE]} />
            <CampaignBlock
                slots={[
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                ]}
            />
            <CampaignBlock
                slots={[
                    Slot.LARGE_SQUARE,
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                ]}
            />
            <CampaignBlock slots={[Slot.SQUARE, Slot.HORIZONTAL_RECTANGLE]} />
            <CampaignBlock
                slots={[
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.LARGE_SQUARE,
                    Slot.SQUARE,
                ]}
            />
            <CampaignBlock slots={[Slot.HORIZONTAL_RECTANGLE, Slot.SQUARE]} />
            <CampaignBlock
                slots={[
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                ]}
            />
            <CampaignBlock slots={[Slot.SQUARE, Slot.HORIZONTAL_RECTANGLE]} />
            <CampaignBlock slots={[Slot.LARGE_SQUARE, Slot.SQUARE, Slot.SQUARE]} />
            <CampaignBlock
                slots={[
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.VERTICAL_RECTANGLE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                    Slot.SQUARE,
                ]}
            />
            <CampaignBlock slots={[Slot.HORIZONTAL_RECTANGLE, Slot.SQUARE]} />
        </DeclarativeGrid>
    );
};

export const ThreeColumnLayout = memo(ThreeColumnLayoutComponent);
